import ApplicationLine from "./ApplicationLine";
import "./main.css";

const Main = ({ implementers, subdivision, goScroll, cancleScroll, slidesToShow }) => {
    return (
        <div className="main" style={{ flex: 1, paddingBottom: 0 }}>
            {implementers ?
                <ApplicationLine
                    implementers={implementers}
                    subdivision={subdivision}
                    goScroll={goScroll}
                    cancleScroll={cancleScroll}
                    slidesToShow={slidesToShow}
                /> : null}
        </div>
    )
};

export default Main;
